import React from 'react'

export interface CardProps {
  children: React.ReactNode
  className?: string
  /**
   * Inner padding. Maps to the design system's 3-tier card inset:
   * `'lg'` = 32px primary card, `'md'` = 24px nested panel, `'sm'` = 16px
   * sub-tile. Booleans are kept for back-compat — `true` → `'md'`, `false` →
   * no padding.
   */
  padding?: boolean | 'sm' | 'md' | 'lg'
  style?: React.CSSProperties
}

const CARD_PADDING = {
  sm: 'var(--spacing-4)',
  md: 'var(--spacing-6)',
  lg: 'var(--spacing-8)',
} as const

export function Card({ children, className = '', padding = true, style }: CardProps) {
  const paddingTier = padding === true ? 'md' : padding === false ? null : padding
  const cardStyle: React.CSSProperties = {
    background: 'var(--color-surface-container-lowest)',
    borderRadius: 'var(--radius-xl)',
    boxShadow: 'var(--shadow-ambient)',
    padding: paddingTier ? CARD_PADDING[paddingTier] : undefined,
    ...style,
  }

  return (
    <div className={className} style={cardStyle}>
      {children}
    </div>
  )
}
